<template>
  <div id='editor' style="width:100%;
            height:500;background: #ffffff;"></div>
</template>
<script>
import E from 'wangeditor'
export default {
  name: '',
  props: ["attachmentCode"],
  data() {
    return {
        wEditor:''
    };
  },
  
  mounted(){
        // wangeditor
    this.wEditor= new E('#editor')
    // 是否过滤粘贴样式
    this.wEditor.config.pasteFilterStyle = true
    // 是否忽略掉粘贴图片
    this.wEditor.config.pasteIgnoreImg = true
    // 上传图片到服务器，base64形式
    this.wEditor.config.uploadImgShowBase64 = true
    this.wEditor.config.uploadFileName = 'file'
    this.wEditor.config.uploadImgMaxSize = 5 * 1024 * 1024
    //上传文件个数
    this.wEditor.config.uploadImgMaxLength = 1
//     this.wEditor.config.uploadImgParams = {
//     attachmentCode:this.attachmentCode
// }
//     this.wEditor.config.uploadImgHeaders = {
//     contentType: 'multipart/form-data',
//     token: "e9a662fe3f7cd961391270880c9559fa",
// }
//     //绑定上传图片的后端地址
//     this.wEditor.config.uploadImgServer = "http://10.30.32.106:8888/college/sys/attachment/upload"
    // 隐藏网络图片
    this.wEditor.config.showLinkImg = false
    // this.wEditor.config.menus = [
    //         'head',  // 标题
    //         'bold',  // 粗体
    //         'fontSize',  // 字号
    //         'fontName',  // 字体
    //         'italic',  // 斜体
    //         'underline',  // 下划线
    //         'foreColor',  // 文字颜色
    //         'quote',  // 引用
    //         'image',  // 插入图片
    //         'code',  // 插入代码
    //         'undo',  // 撤销
    //         'redo'  // 重复
    // ];
    this.wEditor.config.excludeMenus = ['video']
    
    this.wEditor.config.uploadImgHooks = {
        fail: function (xhr, editor, result) {
            this.$message('上传图片失败');
        },
        error: function (xhr, editor) {
            this.$message('上传图片出错');
        },
        timeout: function (xhr, editor) {
            this.$message('上传图片超时');
        },
		//自定义上传图片，回显图片
        customInsert: function (insertImg, result, editor) {
            // var url = result.data[0]
            // window.serverUrl 是nginx图片服务器地址
            // url 是后台返回的上传图片的路径
            // insertImg(window.serverUrl + url)
        }
    }
    // 设置编辑区域高度为 500px
    this.wEditor.config.height = 400
    // 创建一个富文本编辑器
    this.wEditor.create()
    // 富文本内容
    this.wEditor.txt.html(this.content)
  },
  computed: {},
  watch: {},
  methods: {
      getHtml(){
          return this.wEditor.txt.html()
      },
      setHtml(data){
          this.wEditor.txt.html(data)
      }
  },
  components: {},
  filters: {}
};
</script>
<style lang='scss' scoped>
</style>